import React from 'react';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  position: string;
}
export default function TestimonialCard({
  quote,
  author,
  position
}: TestimonialCardProps) {
  return <div className="bg-white rounded-lg shadow-md p-6 h-full flex flex-col card-lift hover:border-l-4 hover:border-secondary transition-all" data-id="element-367">
      <div className="text-secondary mb-4 transform transition-transform hover:scale-110" data-id="element-368">
        <Quote className="h-8 w-8" data-id="element-369" />
      </div>
      <p className="text-slate-dark italic mb-6 flex-grow leading-relaxed" data-id="element-370">
        {quote}
      </p>
      <div className="border-t border-gray-200 pt-4" data-id="element-371">
        <p className="font-bold text-primary" data-id="element-372">{author}</p>
        <p className="text-slate text-sm" data-id="element-373">{position}</p>
      </div>
    </div>;
}